import React from 'react';
import { HashRouter, Routes } from 'react-router-dom';
import './App.css';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Notification from "./Components/firebaseNotification/Notification.js";
import LoadingFallback from './Components/loading/loading.js';
import { AppRoutes } from './routes/index.js';
import { TEST_MODE_STRIPE_PUBLISHABLE_KEY } from './server/index.js';

const stripePromise = loadStripe(TEST_MODE_STRIPE_PUBLISHABLE_KEY);

function App() {
  return (
    <div className="App" >
      <React.Fragment>
        <HashRouter>
          <React.Suspense fallback={<LoadingFallback/>}>
            <Elements stripe={stripePromise}>
              <Notification />
              <Routes>
                {AppRoutes}
              </Routes>
            </Elements>
          </React.Suspense>
        </HashRouter>
      </React.Fragment>
    </div>
  );
}



export default App;